import { createFilledIcon } from "../createIcon";

export const MarkerFilledIcon = createFilledIcon(
  <>
    <path d="M12 2.4c-4.03 0-7.68 3.267-7.68 7.298 0 4.03 5.76 11.902 7.68 11.902s7.68-7.872 7.68-11.902C19.68 5.667 16.031 2.4 12 2.4Zm0 10.56a2.88 2.88 0 1 1 0-5.76 2.88 2.88 0 0 1 0 5.76Z" />
  </>,
  "MarkerFilledIcon"
);
